var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatalogMin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 15 15",
    className: "header__nav-link-icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_902_9752)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.53 1.667H3.408c-.702 0-1.271.569-1.271 1.271v9.123c0 .703.57 1.272 1.271 1.272h9.124c.702 0 1.271-.57 1.271-1.271V2.938c0-.702-.569-1.272-1.271-1.272ZM5.052 1.667v11.666M10.886 1.667v11.666M2.136 7.5h11.666M2.136 4.583h2.916M2.136 10.416h2.916M10.886 10.416h2.916M10.886 4.583h2.916"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_902_9752"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.969.5h14v14h-14z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogMin);
export default __webpack_public_path__ + "static/media/CatalogMin.f53c3b6049e95d8b68f12459c31813bb.svg";
export { ForwardRef as ReactComponent };